import {
  IAdmin,
  IChannel,
  IConference,
  ICourse,
  ICoursesPack,
  ILanguage,
  ILevel,
  INotificationsSettings,
  IPartition,
  IPaymentLink,
  ISeminar,
  ITeacher,
  IUser,
  IUserPayment,
  IWebinar,
  IWordCard,
  IWordCardTag,
  NodeDataT
} from 'shared/types'
import { createAction } from '@reduxjs/toolkit'
import { NodeModel } from '@minoru/react-dnd-treeview'

export const receiveAdmins =
  createAction<Record<string, IAdmin>>('RECEIVE_ADMINS')
export const receiveCourses =
  createAction<Record<string, ICourse>>('RECEIVE_COURSES')
export const receiveCoursesPacks = createAction<Record<string, ICoursesPack>>(
  'RECEIVE_COURSES_PACKS'
)
export const receiveFrees =
  createAction<Record<string, ICourse>>('RECEIVE_FREES')
export const receiveLibrary =
  createAction<Record<string, ICourse>>('RECEIVE_LIBRARY')
export const receiveWebinars =
  createAction<Record<string, IWebinar>>('RECEIVE_WEBINARS')
export const receiveSeminars =
  createAction<Record<string, IWebinar>>('RECEIVE_SEMINARS')
export const receiveConferences = createAction<Record<string, IConference>>(
  'RECEIVE_CONFERENCES'
)
export const receiveUserPayments = createAction<Record<string, IUserPayment>>(
  'RECEIVE_USER_PAYMENTS'
)
export const receivePaymentLinks = createAction<IPaymentLink[]>(
  'RECEIVE_PAYMENT_LINKS'
)
export const receiveUserCourses = createAction<Record<string, ICourse>>(
  'RECEIVE_USER_COURSES'
)
export const receiveUserWebinars = createAction<Record<string, IWebinar>>(
  'RECEIVE_USER_WEBINARS'
)
export const receiveUserSeminars = createAction<Record<string, ISeminar>>(
  'RECEIVE_USER_SEMINARS'
)
export const receiveUserConferences = createAction<Record<string, IConference>>(
  'RECEIVE_USER_CONFERENCES'
)
export const receiveUserLibraryCourses = createAction<Record<string, ICourse>>(
  'RECEIVE_USER_LIBRARY_COURSES'
)

export const receiveNotificationsSettings = createAction<
  Record<string, INotificationsSettings>
>('RECEIVE_NOTIFICATIONS_SETTINGS')

export const logout = createAction('LOGOUT')
export const receiveAuthData = createAction<{
  uid: string
  email: string | null
} | null>('RECEIVE_AUTH_DATA')

export const receivePartitions =
  createAction<Record<string, IPartition>>('RECEIVE_PARTITIONS')

export const receiveLevels =
  createAction<Record<string, ILevel>>('RECEIVE_LEVELS')

export const receiveLanguages =
  createAction<Record<string, ILanguage>>('RECEIVE_LANGUAGES')

export const receiveTeachers =
  createAction<Record<string, ITeacher>>('RECEIVE_TEACHERS')

export const receiveChannels =
  createAction<Record<string, IChannel>>('RECEIVE_CHANNELS')

export const receiveUser = createAction<IUser | null>('RECEIVE_USER')

export const receiveCardTags =
  createAction<Record<string, IWordCardTag>>('RECEIVE_CARD_TAGS')

export const receiveWordCards =
  createAction<Record<string, IWordCard>>('RECEIVE_WORD_CARDS')

export const appendWordCard = createAction<IWordCard>('APPEND_WORD_CARD')

export const receiveFileTree =
  createAction<Partial<Record<string, NodeModel<NodeDataT>[]>>>(
    'RECEIVE_FILE_TREE'
  )
